// @flow

import * as React from "react";

import useInvertedNav from "../../hooks/useInvertedNav";
import useCheckoutNav from "../../hooks/useCheckoutNav";
import { PrimaryNavPad } from "../organisms/PrimaryNav";

import { ReactComponent as Triangle } from "../../../assets/images/shape-triangle.svg";
// import { ReactComponent as Circle } from "../../../assets/images/shape-circle.svg";
import { ReactComponent as Ring } from "../../../assets/images/shape-ring-thick-fill.svg";
import { ReactComponent as Diamond } from "../../../assets/images/shape-diamond.svg";

type PropsType = {
    heading: string,
    beforeContent?: ?any,
    disableCheckoutNav?: boolean,
};

const HeroCheckout = (props: PropsType): React.Node => {
    const baseClassName = "hero-checkout";
    const classes = [baseClassName];

    // invert primary nav color
    useInvertedNav();

    // use simmple checkout nav
    useCheckoutNav(props.disableCheckoutNav);

    return (
        <div className={classes.join(" ")}>
            <PrimaryNavPad />

            {props.beforeContent}

            <div className="hero-checkout__container container-fluid">
                {/* Design elements */}
                <div className="hero-checkout__elements">
                    {/* <Circle className="hero-checkout__circle" /> */}
                    <Ring className="hero-checkout__ring" />
                    <Triangle className="hero-checkout__triangle" />
                    <Diamond className="hero-checkout__diamond" />
                </div>

                <div className="hero-checkout__inner">
                    <h1 className="hero-checkout__heading">{props.heading}</h1>
                </div>
            </div>
        </div>
    );
};

export default HeroCheckout;
